import type { SVGProps } from 'react';
const SvgFoundation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#foundation_svg__a)">
      <path
        fill="currentColor"
        d="M19 12h3L12 3 2 12h3v3H3v2h2v3h2v-3h4v3h2v-3h4v3h2v-3h2v-2h-2v-3ZM7 15v-4.81l4-3.6V15H7Zm6 0V6.59l4 3.6V15h-4Z"
      />
    </g>
    <defs>
      <clipPath id="foundation_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFoundation;
